import React, { memo, MouseEvent } from 'react'
import classNames from 'classnames'
import { Box } from 'transfix-ui/core'
import { AttachmentListItem, IAttachmentsListItem } from './AttachmentListItem'

interface IAttachmentProps {
  /**
   * Show attachment icon to left of file name
   * @default true
   */
  showIcon?: boolean
  attachments?: IAttachmentsListItem[]
  onFileDelete: (event: MouseEvent<HTMLButtonElement>) => void
  /**
   * Enable custom format for title
   */
  getTitle?: (file: IAttachmentsListItem) => string
  isLoading?: boolean
}

export const AttachmentList = memo<IAttachmentProps>(
  ({ attachments = [], isLoading, onFileDelete, showIcon = true, getTitle }) => {
    const attachmentsList = attachments.map((attachment, index) => {
      const isLastChild = attachments.indexOf(attachment) === attachments.length - 1
      const className = classNames({
        mb3: !isLastChild,
      })
      return (
        <AttachmentListItem
          className={className}
          key={attachment?.id}
          attachment={attachment}
          index={index}
          onFileDelete={onFileDelete}
          showIcon={showIcon}
          getTitle={getTitle}
          isLoading={isLoading}
        />
      )
    })

    return <Box>{attachmentsList}</Box>
  }
)
